module.exports = __webpack_public_path__ + "img/phone-call-01.aa8e8b8b.svg";